package com.eladfinish.bible.contest.screens.browse.tableOfContents.ui

import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.ui.components.HorizontalScrollbarContainer
import com.eladfinish.bible.contest.ui.components.buttons.ItemButtonText
import com.eladfinish.bible.contest.ui.components.mouseWheelHorizontalScroll
import com.eladfinish.bible.contest.ui.extensions.horizontalFadingEdge
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.ImmutableList

@Composable
fun <T> ButtonsInRow(
    labels: ImmutableList<Pair<StringResource, T>>,
    onButtonCLick: (T) -> Unit,
    modifier: Modifier = Modifier,
) {
    val state = rememberScrollState()
    HorizontalScrollbarContainer(scrollState = state) {
        Row(
            modifier = modifier
                .horizontalFadingEdge(
                    scrollState = state,
                    length = 20.dp,
                    edgeColor = Color.Black,
                )
                .mouseWheelHorizontalScroll(state)
                .horizontalScroll(state),
        ) {
            labels.forEach {
                ItemButtonText(
                    modifier = Modifier
                        .padding(2.dp),
                    text = stringResource(resource = it.first),
                    borderWidth = 0,
                    onClick = {
                        onButtonCLick(it.second)
                    },
                )
            }
        }
    }
}
